interface UseReadFromClipboard {
  isAvailable(): boolean;
  readText(): Promise<string>;
  readLines(): Promise<string[]>;
  readCells(acceptSpaceAsSeparator?: boolean): Promise<ReadonlyArray<Array<string>>>;
  readCellsAsFlatArray(acceptSpaceAsSeparator?: boolean): Promise<string[]>;
}

export function useReadFromClipboard(
  clipboard: { readText(): Promise<string> } = navigator.clipboard,
): UseReadFromClipboard {
  const isAvailable = () => {
    return clipboard?.readText !== undefined && typeof clipboard.readText === 'function';
  };

  const readText = () => {
    return clipboard.readText();
  };

  const readLines = async () => {
    const text = await readText();
    return text
      .split(/\r|\n|\r\n/)
      .map(line => line.trim())
      .filter(line => line !== '');
  };

  const readCells = async (acceptSpaceAsSeparator: boolean = false) => {
    const lines = await readLines();
    const separator = acceptSpaceAsSeparator ? /\t| / : '\t';
    return lines.map(line =>
      line
        .split(separator)
        .map(cell => cell.trim())
        .filter(cell => cell !== ''),
    );
  };

  const readCellsAsFlatArray = async (acceptSpaceAsSeparator: boolean = false) => {
    const cells = await readCells(acceptSpaceAsSeparator);
    return cells.reduce<string[]>((acc, row) => [...acc, ...row], []);
  };

  return {
    isAvailable,
    readText,
    readLines,
    readCells,
    readCellsAsFlatArray,
  };
}
